<template>
  <v-card class="mt-4">
    <v-toolbar>
      <v-toolbar-title>
        <v-icon>mdi-map-marker</v-icon> 
        {{ i18n.global.t('pages.vehicleInstall.map.title') }}
      </v-toolbar-title>
    </v-toolbar>
    <div class="loading w-100 d-flex justify-center align-center" v-if="!props.isLoadingFinished">
      <div class="max-w-md w-full space-y-8">
        <VLoaderAnimation
          :text="'text-black'"
          :loading-text="i18n.global.t('pages.vehicleInstall.map.waitingLocationInfo')"
          :loading-text-style="'text-black text-lg'"
          :addCharacterImg="false"
        />
      </div>
    </div>
    <div
      v-if="props.errorMessage"
      class="error-message w-100 d-flex justify-center align-center"
    >
      <v-alert
        type="error"
        class="col-8"
      >
        {{ props.errorMessage }}
      </v-alert>
    </div>
    <GMapMap
      :center="props.vehiclePosition?.position ?? safeCenterCoordinates"
      :zoom="props.zoomLevel"
      map-type-id="roadmap"
    >
      <GMapMarker
        v-if="props.isMarkerVisible && props.vehiclePosition"
        :position="props.vehiclePosition?.position ?? safeCenterCoordinates"
        :clickable="true"
        :draggable="false"
        @click="isInfoWindowOpen = true"
      >
        <GMapInfoWindow
          :closeclick="true"
          :opened="isInfoWindowOpen"
          @closeclick="handleInfoWindowClose"
        >
          <InfoWindowContents
            ref="infoWindowContents"
            :vehicleInfo="vehicleInfo"
            :vehiclePosition="vehiclePosition"
          />
        </GMapInfoWindow>
      </GMapMarker>
    </GMapMap>
  </v-card>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import VLoaderAnimation from '@/components/template/v-loader-animation.vue';
import InfoWindowContents from '@/components/VehicleInstall/InfoWindowContents.vue';
import i18n from '@/lang/i18n';
import VehicleTimedPosition from '@/types/VehicleTimedPosition';
import getVehicleResponse from '@/types/responses/getVehicle';
import { safeCenterCoordinates } from '@/services/consts';

const props = defineProps<{
  vehiclePosition: VehicleTimedPosition | null;
  vehicleInfo: getVehicleResponse | null;
  zoomLevel: number;
  isMarkerVisible: boolean;
  isLoadingFinished: boolean;
  errorMessage?: string;
}>();

const isInfoWindowOpen = ref(false);
const infoWindowContents = ref<InstanceType<typeof InfoWindowContents> | null>(null);

function handleInfoWindowClose() {
  isInfoWindowOpen.value = false;
  if (infoWindowContents.value) {
    infoWindowContents.value.clearVehicleAddress();
  }
}

</script>

<style scoped>
.vue-map-container {
  height: 70vh;
}
.loading {
  background-color: rgba(250, 250, 250, 0.7);
  height: 70vh;
  position: absolute;
  z-index: 1000;
}
.error-message {
  background-color: rgba(250, 250, 250, 0.7);
  height: 70vh;
  position: absolute;
  z-index: 1001;
}

@media (max-width: 840px) {
  .vue-map-container {
    height: 40vh;
  }
  .loading {
    height: 40vh;
  }
  .error-message {
    height: 40vh;
  }
}
</style>
